import React from 'react';
import { category1, category2, category3, stars } from '../../../assets/images';
import { useTranslation } from 'react-i18next';

const Comments = () => {

  const { t, i18n } = useTranslation(); 
  return ( 
     <div className="md:max-w-container md:mt-[154px] mt-[64px] gap-5 rounded-[24px] pt-10 md:pt-0 pb-10 md:pb-0 md:pl-[40px] bg-[#FB8C00] max-w-containerSm mx-auto md:flex items-center">
   <div className='md:w-[562px] text-white px-3 md:pl-0'>
  <p className='md:text-[46px] text-3xl font-medium leading-[55px] '>{t("Rəyinizlə daha yaxşıya doğru !")}</p>
  <p className='mt-[22px] md:text-xl'>{t("Müştərilərimizin rəyləri sizin üçün doğru seçim olduğumuzu sübut edir. Bizi seçənlərin xoş təcrübələrini burada görün. Onların sözləri bizim motivasiyamızdır!")}</p>
  <button className='bg-white h-[51px] w-[179px] rounded-[12px] mt-[33px] text-black'>{t("Ətraflı bax")}</button>
   </div>
   <div className='md:w-[615px] flex flex-col justify-center items-center mt-10 md:mt-0'>
  <div className='md:h-[174px] w-[90%] md:w-[527px] rounded-[21px] border border-[#388e3c] px-6 py-4 bg-[white]'>
 <div className='flex justify-between items-center'>
  <p className='text-xl'>{t("Sophia Bennett")}</p>
  <div>
    <img className='w-[80px] h-[16px]' src={stars}></img>
  </div>
 </div>
 <div className='mt-2'>
<p>{t("“Bu şirkət ilə əməkdaşlıq etmək çox rahat oldu. Hevo-ya müraciət etdim və Türkiyədə müalicə aldım. Sağlamlığımla bağlı göstərilən xidmətlərdən çox məmnun qaldım. Həkimlər və heyət çox peşəkar və diqqətlidirlər. Çox təşəkkür edirəm!”")}</p>
 </div>
  </div>
  <div className='md:h-[174px] w-full mt-2 rounded-[21px] border border-[#388e3c] px-6 py-4 bg-[white]'>
 <div className='flex justify-between items-center'>
  <p className='text-xl'>{t("Fərid Məmmədov")}</p>
  <div>
    <img className='w-[80px] h-[16px]' src={stars}></img>
  </div>
 </div>
 <div className='mt-2'>
<p>{t("“Hevo'ya müraciət etdim və təcrübə məqsədilə Almaniyaya getdim. Bu, yalnız tibbi biliklərimi artırmaqla qalmadı, həm də müxtəlif mədəniyyətləri və yanaşmaları tanımağa kömək etdi. Şirkətin təcrübə mübadiləsi proqramları çox yaxşı təşkil olunub.”")}</p>
 </div>
  </div>
  <div className='md:h-[174px] w-[90%] md:w-[527px] mt-2 rounded-[21px] border border-[#388e3c] px-6 py-4 bg-[white]'>
 <div className='flex justify-between items-center'>
  <p className='text-xl'>{t("Liam Anderson")}</p>
  <div>
    <img className='w-[80px] h-[16px]' src={stars}></img>
  </div>
 </div>
 <div className='mt-2'>
<p>{t("“Şirkətin tibbi xidmətləri çox yüksək səviyyədədir. Həkimlər çox diqqətcil və peşəkar idi. Müalicə prosesim boyunca daim dəstək oldular və hər addımda mənə rəhbərlik etdilər. Səhhətimdə böyük irəliləyişlər gördüm və çox məmnun qaldım.”")}</p>
 </div>
  </div>
   </div>
    </div>
  );
};

export default Comments;
